import React, { useEffect, useState } from "react";
import "./Style.css";
import { changingTabsWithCustomButton } from "../../../../Redux/actions/Dashboard/Dashboard";
import { resetSrfSearchData } from "../../../../Redux/actions/Srf/Srf";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import PurpleTag from "../../../../images/purple-tag.png";

const Style = ({ sockId, promisedExFactory,vendor,season, brand }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log("promisedExFactory",promisedExFactory);
  // const onParentStyleClicked = () => {
  //   localStorage.setItem(
  //     "DashboardData",
  //     JSON.stringify({
  //       style: sockId,
  //       factory: vendor,
  //       season: season,
  //       brand: brand,
  //     })
  //   );
  //   localStorage.removeItem("srtMassData");
  //   localStorage.removeItem("massFilterData");
  //   dispatch(resetSrfSearchData([]));
  //   localStorage.setItem("RequestSend", false);
  //   dispatch(changingTabsWithCustomButton("true.2"));
  //   localStorage.removeItem("SrfSearchData");
  //   navigate("/sample-request-form");
  // };

  return (
    <div className="style-wrapper">
      <p className="style-title">Parent Style</p>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {/* <p className="socks-id" onClick={onParentStyleClicked}> */}
        <p className="socks-id">
          {sockId}
        </p>
        {promisedExFactory?.isNewStyleKey && (
          <img width={15} height={15} src={PurpleTag} alt="Tag" />
        )}
      </div>
    </div>
  );
};

export default Style;
